import { vehiclesServices } from './vehicles';
import { subscriptionsServices } from './subscriptions';
import { usersServices } from './users';
import { servicePointsServices } from './servicePoints';
import { googlePlacesServices } from './googlePlaces';
import { insurancesServices } from './insurances';
import { overviewServices } from './overview';
import { bookingsServices } from './bookings';
import { roadsideAssistanceServices } from './roadsideAssistance';
import { utilitiesServices } from './utilities';
import { serviceVehiclesServices } from './serviceVehicles';
import { agentsServices } from './agents';
import { subscribersServices } from './subscribers';
import { fleetVehiclesServices } from './fleetVehicles';
import { oauthServices } from './oauth';
import { globalSearchServices } from './globalSearch';
import { configurationServices } from './configuration';
import { permissionsServices } from './permissions';
import { routesServices } from './routes';
import { graphServices } from './graph';
import { boardsServices } from './boardsServices';
import { reportsServices } from './reports';
import { marketingServices } from './marketing';
import { notificationsServices } from './notifications';
import { driversServices } from './driversServices';
import { mediaServices } from './media';
import { ebikesServices } from './ebike';
import { ordersServices } from './orders';
import { vendorsServices } from './vendors';
import { productsServices } from './products';
import { pricingServices } from './pricing';
import { availabilityServices } from './availabilityServices';
import { reservationServices } from './reservations';
import { partnersServices } from './partners';
import { creditCheckServices } from './creditCheck';
import { sellVehiclesServices } from './sellVehicles';
import { teamsServices } from './teams';
import { communicationServices } from './communication';
import { videosServices } from './videos';
import { b2bServices } from './b2b';
import { procurementServices } from './procurement';
import { customerVehiclesServices } from './customerVehicles';
import { competitionServices } from './competition';
import { guaranteeReturnsServices } from './guaranteeReturns';
import { tradeTicketsServices } from './tradeTickets';
import { genericTicketsServices } from './genericTickets';
import { sellVehiclesB2BServices } from './sellVehiclesB2B';
import { tiresServices } from './tires';

export {
  vehiclesServices,
  subscriptionsServices,
  usersServices,
  servicePointsServices,
  googlePlacesServices,
  insurancesServices,
  overviewServices,
  bookingsServices,
  roadsideAssistanceServices,
  utilitiesServices,
  serviceVehiclesServices,
  agentsServices,
  subscribersServices,
  fleetVehiclesServices,
  oauthServices,
  globalSearchServices,
  configurationServices,
  permissionsServices,
  routesServices,
  graphServices,
  boardsServices,
  reportsServices,
  marketingServices,
  notificationsServices,
  driversServices,
  mediaServices,
  ebikesServices,
  ordersServices,
  vendorsServices,
  productsServices,
  pricingServices,
  availabilityServices,
  reservationServices,
  partnersServices,
  creditCheckServices,
  sellVehiclesServices,
  teamsServices,
  communicationServices,
  videosServices,
  b2bServices,
  procurementServices,
  customerVehiclesServices,
  competitionServices,
  guaranteeReturnsServices,
  tradeTicketsServices,
  genericTicketsServices,
  sellVehiclesB2BServices,
  tiresServices,
};
